import { ViewMode } from '../../constants/enums'

export interface OrientationViewModeInput {
    viewMode: ViewMode
    /** The mode a previous orientation change displaced, or null */
    restoreViewMode: ViewMode | null
    isVertical: boolean
    isMobile: boolean
    /** Mobile landscape in a room or PM with the full-window setting on */
    autoFullWindow: boolean
}

export interface OrientationViewModeResult {
    viewMode: ViewMode
    restoreViewMode: ViewMode | null
}

/*
    Orientation never replaces the user's view mode, it displaces it. Landscape
    on mobile either auto-enters full window or, when that is opted out, drops
    theater (a portrait-only layout on mobile) to normal, remembering what it
    displaced. Portrait puts the remembered mode back. Full window never
    survives a portrait orientation.
*/
export const resolveOrientationViewMode = ({
    viewMode,
    restoreViewMode,
    isVertical,
    isMobile,
    autoFullWindow,
}: OrientationViewModeInput): OrientationViewModeResult => {
    if (!isVertical) {
        if (autoFullWindow && viewMode !== ViewMode.FullWindow) {
            return {
                viewMode: ViewMode.FullWindow,
                restoreViewMode: restoreViewMode ?? viewMode,
            }
        }
        if (isMobile && viewMode === ViewMode.Theater) {
            return {
                viewMode: ViewMode.Normal,
                restoreViewMode: ViewMode.Theater,
            }
        }
        return { viewMode, restoreViewMode }
    }
    if (viewMode === ViewMode.FullWindow) {
        return {
            viewMode: restoreViewMode ?? ViewMode.Normal,
            restoreViewMode: null,
        }
    }
    if (restoreViewMode !== null && viewMode === ViewMode.Normal) {
        return { viewMode: restoreViewMode, restoreViewMode: null }
    }
    return { viewMode, restoreViewMode }
}
